<div class="rb-load-indicator-container" [class.loading]="show">
	<div class="rb-load-indicator-loader" *ngIf="show">
		<mat-spinner [diameter]="50" />
		<h4>Cargando...</h4>
	</div>
	<ng-content />
</div>
